import React from 'react';

import DetailedViewCard from 'components/Meteorology/Agro/WaterBalanceSequential/DetailedViewCard';
import DetailedViewCardMobile from 'components/Meteorology/Agro/WaterBalanceSequential/DetailedViewCard/Mobile';
import GroupLocationDeleteFeedback from 'components/Meteorology/Agro/GroupLocationDeleteFeedback';
import useRedirectFromMap from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/useRedirectFromMap';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function DetailedView() {
  useRedirectFromMap();
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <>
        <GroupLocationDeleteFeedback />
        <DetailedViewCardMobile />
      </>
    );
  }

  return (
    <>
      <GroupLocationDeleteFeedback />
      <DetailedViewCard />
    </>
  );
}
